export default "__VITE_ASSET__d48b1661__"